import React from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react-pro'

type TProps = {
  isOpen: boolean
  onSubmit: () => void
  onCancel: () => void
}

export const ConfirmDetachModal: React.FC<TProps> = ({
  isOpen,
  onSubmit,
  onCancel,
}) => {
  return (
    <CModal visible={isOpen} onClose={onCancel}>
      <CModalHeader>Confirm</CModalHeader>
      <CModalBody>Are you sure you want to detach the client from the partner?</CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cancel
        </CButton>
        <CButton color="primary" className="px-4" onClick={onSubmit}>
          Ok
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
